import get from 'lodash.get';
import { Box, Text } from '@wix/design-system';
import * as React from 'react';
import css from './RecurringInvoicesView.scss';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { frequencyTranslations } from '../RecurringPayView/RecurringPayView';
import { currencyFormat, newMobileViewBreakpoint } from '../../core';
import { isMobileView } from '../../core/isMobileView';
import { WithRecurringViewLoader, } from '../loaders/loaders-builder';
import RecurringDetailsCard, { PaymentType, } from './RecurringDetailsCard/RecurringDetailsCard';
const RecurringInvoiceView = ({ invoice, recurringStandaloneViewEnabled, darkView, newMobileView = false, t, }) => {
    const { currencyCode, metaData } = invoice;
    const { billingCycle, numberOfBillingCycles, frequency } = metaData?.sourceProperties || {};
    const invoiceAmount = get(invoice, 'totals.total.serializedValue', 0);
    const currency = currencyFormat({
        currency: currencyCode,
        locale: invoice.locale?.language,
    });
    const isUnlimitedBilling = numberOfBillingCycles === '0';
    const darkBackgroundColorIfNeeded = !recurringStandaloneViewEnabled && darkView ? css.containerDarkBgColor : '';
    const textSize = isMobileView() || newMobileView ? 'tiny' : 'small';
    const titleWeight = newMobileView ? 'thin' : 'normal';
    const valueWeight = newMobileView ? 'normal' : 'bold';
    const maxWidth = newMobileView ? newMobileViewBreakpoint : '';
    return (React.createElement("div", { "data-hook": "recurring-section", className: `${css.container} ${darkBackgroundColorIfNeeded}`, style: newMobileView
            ? {
                backgroundColor: 'white',
                paddingLeft: '5%',
                paddingRight: '5%',
                paddingBottom: '18px',
                paddingTop: '18px',
                maxWidth,
            }
            : {
                width: '867px',
            } }, recurringStandaloneViewEnabled ? (React.createElement(RecurringDetailsCard, { paymentType: PaymentType.AUTOMATIC, recurringPayment: parseFloat(billingCycle), totalRecurringPayments: parseFloat(numberOfBillingCycles), billingCycle: frequency })) : (React.createElement(Box, { dataHook: "recurring-details-section", direction: "vertical", maxWidth: maxWidth },
        React.createElement("div", { className: css.row, "data-hook": "payments-row", style: { maxWidth } },
            React.createElement(Text, { light: darkView, size: textSize, weight: titleWeight, dataHook: "payments-title", secondary: !darkView }, `${t('recurring-payment-uou.title')} `),
            React.createElement(Text, { light: darkView, size: textSize, weight: valueWeight, dataHook: "payments-value" }, isUnlimitedBilling
                ? t('recurring-payment-uou.title.unlimited', { billingCycle })
                : t('recurring-payment-uou.title.limited', {
                    billingCycle,
                    numberOfBillingCycles,
                }))),
        React.createElement("div", { className: css.row },
            React.createElement(Text, { light: darkView, size: textSize, weight: titleWeight, dataHook: "amount-title", secondary: !darkView }, `${t('invoice.view.recurring.amount.title')} `),
            React.createElement(Text, { light: darkView, size: textSize, weight: valueWeight, dataHook: "amount-value" }, currency(invoiceAmount || 0))),
        React.createElement("div", { className: css.row },
            React.createElement(Text, { light: darkView, size: textSize, weight: titleWeight, dataHook: "cycle-title", secondary: !darkView }, `${t('invoice.view.recurring.cycle.title')} `),
            React.createElement(Text, { light: darkView, size: textSize, weight: valueWeight, dataHook: "cycle-value" }, t(frequencyTranslations[frequency.toLocaleLowerCase()])))))));
};
export default WithRecurringViewLoader(withTranslation(['invoice-view', 'locale-data'])(RecurringInvoiceView));
//# sourceMappingURL=RecurringInvoicesView.js.map